import { readonly, ref, useContext } from "@nuxtjs/composition-api";
import { Logger } from "@wemade-vsf/core";
import { getProductListCommand } from "./commands/getProductListCommand";
import { getProductDetailsCommand } from "./commands/getProductDetailsCommand";
function useProduct(id) {
  const loading = ref(false);
  const error = ref({
    getProductList: null,
    getProductDetails: null
  });
  const context = useContext();
  const getProductList = async (searchParams) => {
    var _a, _b, _c, _d, _e, _f;
    Logger.debug(`useProduct/${id}/getProductList`, searchParams);
    let products = null;
    const includeLabels = ((_c = (_b = (_a = context.app.$wm) == null ? void 0 : _a.catalog) == null ? void 0 : _b.productList) == null ? void 0 : _c.includeLabels) || true;
    const customAttributes = ((_f = (_e = (_d = context.app.$wm) == null ? void 0 : _d.catalog) == null ? void 0 : _e.productList) == null ? void 0 : _f.customAttributes) || [];
    if (searchParams.includeLabels === void 0)
      searchParams.includeLabels = includeLabels;
    if (searchParams.customAttributes === void 0)
      searchParams.customAttributes = customAttributes;
    searchParams.isDetailProduct = false;
    try {
      loading.value = true;
      products = await getProductListCommand.execute(context, searchParams);
      error.value.getProductList = null;
    } catch (err) {
      error.value.getProductList = err;
      Logger.error(`useProduct/${id}/search`, err);
    } finally {
      loading.value = false;
    }
    return products;
  };
  const getProductDetails = async (searchParams, customQuery = { productDetail: "productDetail" }) => {
    var _a, _b, _c, _d, _e, _f, _g;
    Logger.debug(`useProduct/${id}/getProductDetails`, searchParams);
    let products = null;
    const includeLabels = (_d = (_c = (_b = (_a = context.app.$wm) == null ? void 0 : _a.catalog) == null ? void 0 : _b.productDetail) == null ? void 0 : _c.includeLabels) != null ? _d : true;
    const customAttributes = ((_g = (_f = (_e = context.app.$wm) == null ? void 0 : _e.catalog) == null ? void 0 : _f.productDetail) == null ? void 0 : _g.customAttributes) || [];
    if (searchParams.includeLabels === void 0)
      searchParams.includeLabels = includeLabels;
    if (searchParams.customAttributes === void 0)
      searchParams.customAttributes = customAttributes;
    searchParams = {
      includeAggregations: false,
      includePagination: false,
      isDetailProduct: true,
      ...searchParams
    };
    try {
      loading.value = true;
      products = await getProductDetailsCommand.execute(context, searchParams, customQuery);
      error.value.getProductDetails = null;
    } catch (err) {
      error.value.getProductDetails = err;
      Logger.error(`useProduct/${id}/search`, err);
    } finally {
      loading.value = false;
    }
    return products;
  };
  const getProductPath = (product) => {
    var _a, _b, _c;
    if (!product)
      return "/";
    return `/${(_c = (_b = (_a = product == null ? void 0 : product.url_rewrites) == null ? void 0 : _a[0]) == null ? void 0 : _b.url) != null ? _c : product.url_key}`;
  };
  return {
    getProductList,
    getProductDetails,
    getProductPath,
    error: readonly(error),
    loading: readonly(loading)
  };
}
export * from "./useProduct";
var useProduct_default = useProduct;
export {
  useProduct_default as default,
  useProduct
};
